// extracted by mini-css-extract-plugin
export var blue = "_3k-h";
export var brand = "_3k-d";
export var darkGrey = "_3k-g";
export var disabled = "_3k-6";
export var disabledSubtle = "_3k-7";
export var error = "_3k-8";
export var green = "_3k-i";
export var grey = "_3k-f";
export var icon = "_3k-0";
export var inherit = "_3k-c";
export var lightGrey = "_3k-e";
export var orange = "_3k-k";
export var pink = "_3k-m";
export var primary = "_3k-1";
export var purple = "_3k-n";
export var quaternary = "_3k-4";
export var quinary = "_3k-5";
export var red = "_3k-l";
export var secondary = "_3k-2";
export var success = "_3k-b";
export var tertiary = "_3k-3";
export var warning = "_3k-9";
export var warningSecondary = "_3k-a";
export var white = "_3k-o";
export var yellow = "_3k-j";